import { render, staticRenderFns } from "./CommentSectionWrapper.vue?vue&type=template&id=4b827dca&scoped=true&"
import script from "./CommentSectionWrapper.vue?vue&type=script&lang=js&"
export * from "./CommentSectionWrapper.vue?vue&type=script&lang=js&"
import style0 from "./CommentSectionWrapper.vue?vue&type=style&index=0&id=4b827dca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b827dca",
  null
  
)

export default component.exports